import React from 'react';

/**
 * Can delete but not edit content.
 */
const EditableTag = ({ label, handleDelete }) => {
    return (
        <>
            <div className='editable-item-tag'>
                <span className='tag-text'>{label}</span>
                <div className='tag-vline' />
                <div className='tag-button' onClick={handleDelete}>
                    &times;
                </div>
            </div>
        </>
    );
};

export default EditableTag;
